import { render, staticRenderFns } from "./AbnormalPunchReason.vue?vue&type=template&id=0ae19bb6&"
import script from "./AbnormalPunchReason.vue?vue&type=script&lang=js&"
export * from "./AbnormalPunchReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae19bb6')) {
      api.createRecord('0ae19bb6', component.options)
    } else {
      api.reload('0ae19bb6', component.options)
    }
    module.hot.accept("./AbnormalPunchReason.vue?vue&type=template&id=0ae19bb6&", function () {
      api.rerender('0ae19bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Punch/AbnormalPunchReason/AbnormalPunchReason.vue"
export default component.exports